import React, { useEffect, useState, useRef } from "react";
import FluidImage from "../../components/fluidImage";
import { render } from "storyblok-rich-text-react-renderer";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade } from "swiper";
import Arrow from "./Arrow";
import "swiper/css";
import "swiper/css/effect-fade";
import Link from "../../utils/link";

const NameList = (props) => {

    /*
     Inverting the senior_role boolean allows us to use the same component for both the senior and junior team members.
    */

    return (
        <ol className={`lg:pt-36 pt-[84px] pb-8 lg:pb-0 space-y-4 lg:space-y-8 width-padding flex flex-col lg:ml-4 lg:mb-10`}>
            {
                props.blocks.map((block, index) => {

                    const dropdownRef = useRef(null)

                    const getMaxHeight = (index) => {
                        if (typeof window === `undefined`) return `0px`

                            if (dropdownRef.current) {
                                return props.activeIndex == index ? `${dropdownRef.current.scrollHeight}px` : `0px`
                            }
                        
                        if (index == 0) {
                            return `2000px`
                        }
                        return `0px`
                    }

                    return (
                        <li key={`team-selector-${index}`} className={``}>

                            <button className={`font-serif lg:w-fit text-[27px] lg:text-4xl font-extralight transition-opacity duration-300 team-member-name scroll-m-5 ${props.activeIndex == index ? `opacity-100 active` : `opacity-[0.35] hover:opacity-50 `}`} onClick={() => props.setActiveIndex(index)}>                            
                            {block.name}
                            </button>
                            <div className={`${index == 0 ? `` : `max-h-0`} overflow-hidden transition-all duration-500
                             ${props.activeIndex == index ? `opacity-100` : `opacity-0`} `} ref={dropdownRef} style={{
                                    maxHeight: getMaxHeight(index)
                                }
                                }>
                                <FluidImage image={block.image} key={`team-image-${block.name}`} className={`!h-[512px] lg:!h-screen !w-full my-8 lg:hidden`} />
                                <Summary block={block} />
                            </div>

                        </li>
                    )
                })
            }
        </ol>
    )
}

const Summary = ({ block }) => {

    return (
        <div className={`lg:col-span-2 bg-off-white mb-4 lg:mb-0`}>
            <p className="text-3xl lg:text-4xl font-thin font-serif lg:mr-12 pb-8 lg:pb-10 lg:mt-10">
                {block.bio_summary}
            </p>

            <div className="lg:flex lg:space-x-11 lg:space-y-0 lg:text-lg lg:ml-16 lg:mb-4">
                <div className="lg:max-w-md space-y-5 lg:space-y-6">
                    {render(block.long_bio)}

                    {render(block.long_bio_right_col)}
                    {
                        block.contact_link.url && (
                            <Link to={block.contact_link.url} className="!mt-6 flex space-x-4 text-base lg:text-lg font-semibold lg:ml-auto lg:mr-8 group relative">
                                <Arrow /> <span className="group-hover:opacity-0 transition-opacity duration-300">Get in touch</span>
                            </Link>
                        )
                    }

                </div>
     


            </div>
        </div>
    )
}

const OurTeam = (props) => {

    const swiperRef = useRef(null)

    const blocks = props.blok.team_member

    const [activeIndex, setActiveIndex] = useState(0)
    const [hasInit, setHasInit] = useState(false)

    useEffect(() => {
        if (window.innerWidth > 1024) {
            setHasInit(true)
        } else {
            // in 500ms
            setTimeout(() => {

                if (hasInit == true) {

                    document.querySelector('.team-member-name.active').scrollIntoView({ behavior: 'smooth' });
                } else {
                    setHasInit(true)
                }

            }, 500)
        }
    }, [activeIndex])


    // removed max-w-[1920px] 

    return (
        <section className="mx-auto relative">

            <div className="grid lg:grid-cols-2 ">

                <NameList blocks={blocks} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />

                <div className="relative lg:sticky lg:top-0 mx-[20px] lg:mx-0 lg:h-screen hidden lg:block z-[1]">
                    {
                        blocks.map((block, index) => {
                            return (
                                <FluidImage image={block.image} critical={index == 0} key={`team-image-${index}`} className={`h-[512px] lg:!h-screen !w-full inset-0 duration-300 transition-opacity isolate ${index == 0 ? `` : ` !absolute`} ${activeIndex == index ? `opacity-100` : `opacity-0`}`} />
                            )
                        })}
                </div>
            </div>
            {/* 
            <div className="width-padding pt-8 lg:pt-24 pb-10 lg:pb-24 slide-info hidden lg:block">

                <Swiper
                    spaceBetween={0}
                    effect={"fade"}
                    slidesPerView={1}
                    navigation={false}
                    modules={[EffectFade]}
                    allowTouchMove={false}
                    ref={swiperRef}
                    autoHeight={true}
                >
                    {
                        blocks.map((block, index) => {
                            return (
                                <SwiperSlide key={`team-slide-${index}`}>
                                    <Summary block={block} />
                                </SwiperSlide>)
                        })}
                </Swiper>

            </div>
        
                   <NameList blocks={blocks} activeIndex={activeIndex} setActiveIndex={setActiveIndex} mobile={true} /> */
            }



        </section>
    )
}

export default OurTeam